import React from 'react';
import Modal from 'react-modal';
import { CloseBtn } from '../UI/Modal';

const EditModal = ({ open, onClose, children }) => {
    return (
        <Modal
            isOpen={open}
            onClose={onClose}
            onRequestClose={onClose}
            className="Modal notification-modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
        >
            <CloseBtn onClose={onClose} />
            {children}
        </Modal>
    );
};

export default EditModal;
